// import { animate, spring } from "motion";
import { initAnimNewsCircle, initAnimNewsItems } from "./animations";
import initImageModals from "./imageModals";

function newsLoaded() {
  document.addEventListener("facetwp-loaded", function () {
    initAnimNewsCircle();

    const isBlogtPage = document.body.classList.contains("blog");

    if (isBlogtPage) {
      initAnimNewsItems();
    }

    initImageModals();
  });
}

export { newsLoaded };

function addBodyClass() {
  function updateBodyClass() {
    var facets = document.querySelectorAll(".facetwp-facet");
    var anyFacetSelected = false;

    facets.forEach(function (facet) {
      var checkboxes = facet.querySelectorAll(".facetwp-checkbox.checked");
      var radios = facet.querySelectorAll(".facetwp-radio.checked");
      var dropdowns = facet.querySelectorAll(
        ".facetwp-dropdown option:checked"
      );

      if (
        checkboxes.length > 0 ||
        radios.length > 0 ||
        Array.from(dropdowns).some((option) => option.value)
      ) {
        anyFacetSelected = true;
        return; // Exit loop early
      }
    });

    if (anyFacetSelected) {
      document.body.classList.add("facet-selected");
    } else {
      document.body.classList.remove("facet-selected");
    }
  }

  document.addEventListener("facetwp-loaded", function () {
    updateBodyClass();
  });
}

export { addBodyClass };
